// extracted by mini-css-extract-plugin
export default {"tab-component":"HxkUClxq","large":"b8x2N_QX","small":"DnWofyJi","active":"Ds1eTCf0","loading":"ladpF0cV"};